<div #dropdown class="dropdown">
  <button #button class="btn btn-bg-secondary text-start d-flex justify-content-between align-items-center w-100 p-2"
          type="button"
          [ngClass]="hasValue ? 'btn-active' : ''" data-bs-toggle="dropdown" data-bs-auto-close="outside">
    <div class="d-flex flex-column mw-0 flex-grow-1 me-3">
      <span class="d-inline-block text-truncate">{{ filterName }}</span>
      @if (hasValue) {
        <div class="mt-1 text-secondary d-inline-block text-truncate">
          {{ selectedValueFormatter ? selectedValueFormatter(value) : null }}
        </div>
      }
    </div>
    @if (!hasValue) {
      <i class="fa fa-fw fa-plus text-secondary"></i>
    }
  </button>
  <div class="btn-close-wrapper rounded-circle position-absolute end-0 me-2 mt-2 top-0"
       [ngClass]="{'d-none': !hasValue}">
    <button type="button" class="btn-close" (click)="removeFilter()" aria-label="Remove filter"></button>
  </div>
  <div class="dropdown-menu min-w-100 overflow-hidden dropdown-menu-flex" [style.max-height.px]="320">
    <div class="d-flex flex-column w-100 mh-100">
      <div class="p-3 border-bottom">
        <app-filter [appAutoFocus]="true" [autoFocusInOverlay]="true" placeholder="Search..."
                    [searchFunction]="searchFunction" [debounceTime]="1000" [minCharacters]="minCharacters"
                    (resultsFound)="results = $event" class="border-0"></app-filter>
      </div>
      <app-scroller class="overflow-y-auto">
        <ul class="list-group">
          @for (value of results; track $index) {
            @if (value) {
              <li (click)="selectValue(value)" class="list-group-item list-group-item-action border-0 d-flex align-items-stretch p-0">
                <div class="d-flex align-items-center py-2 px-3 cursor-pointer">
                  {{inputFormatter(value)}}
                </div>
              </li>
            }
          }
        </ul>
      </app-scroller>
    </div>
  </div>
</div>
